import { useCallback, useState } from 'react';

export const usePromise = (fn: VoidFunction | (() => Promise<void>)) => {
  const [isPending, setIsPending] = useState(false);
  const [error, setError] = useState<unknown>(null);
  const isError = error !== null;
  const isSuccess = !isPending && !isError;

  const handler = useCallback(async () => {
    if (isPending) return;

    setIsPending(true);
    setError(null);

    try {
      await fn();
    } catch (error) {
      setError(error);
    } finally {
      setIsPending(false);
    }
  }, [fn, isPending]);

  return { isError, isPending, isSuccess, handler, error };
};
